<template>
<div>
  <el-button type="success"
             @click="resetCompanies();$modal.show('job-dialog');">
    자동 입력
  </el-button>
  <modal name="job-dialog"
         :adaptive="true"
         :scrollable="true"
         height="auto">
    <div class="v--modal-close-top">
      <el-button @click="$modal.hide('job-dialog');"
                 icon="el-icon-close"
                 type="text"></el-button>
    </div>
    <div class="title">경력자동 입력</div>
    <p>회사명과 근무기간을 바탕으로 입사·퇴사 표기를 자동으로 작성합니다.</p>
    <p>&nbsp;</p>
    <div class="edit-form">
      <div class="edit-form-item">
        <div class="item-name">회사명</div>
        <div class="item-body">
          <el-input class="input-md"
                    placeholder="회사명 입력"
                    title="회사명"
                    v-model="company.name"
                    @keyup.native.enter="$formLib.nextInput($refs.startYear)"
                    ref="companyName"></el-input>
        </div>
      </div>
      <div class="edit-form-item">
        <div class="item-name">근무기간</div>
        <div class="item-body job-auto-input-period">
          <div class="period-start">
            <el-input class="input-xxs"
                      placeholder="2000"
                      title="년"
                      v-model="company.startYear"
                      type="number"
                      :min="calcMinYear"
                      :max="calcMaxYear"
                      :maxlength="4"
                      @keyup.native.enter="$formLib.nextInput($refs.startMonth)"
                      ref="startYear"></el-input><span>년</span>
            <el-input class="input-xxs input-2-digit"
                      placeholder="1"
                      title="월"
                      v-model="company.startMonth"
                      type="number"
                      min="1"
                      max="12"
                      @keyup.native.enter="$formLib.nextInput($refs.endYear)"
                      ref="startMonth">
            </el-input><span>월부터</span>
          </div>
          <div class="period-end">
            <el-input class="input-xxs"
                      placeholder="2018"
                      title="년"
                      v-model="company.endYear"
                      :min="calcMinYear"
                      :max="calcMaxYear"
                      type="number"
                      ref="endYear"
                      @keyup.native.enter="$formLib.nextInput($refs.endMonth)"
                      :disabled="isContinuing"></el-input><span>년</span>
            <el-input class="input-xxs input-2-digit"
                      placeholder="12"
                      title="월"
                      v-model="company.endMonth"
                      type="number"
                      min="1"
                      max="12"
                      ref="endMonth"
                      :disabled="isContinuing">
            </el-input><span>월까지</span>
            <div class="tenure">
              <el-checkbox v-model="isContinuing">재직중</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="edit-form-item"
           v-if="!isContinuing">
        <div class="item-name">퇴사사유</div>
        <div class="item-body">
          <div class="radio-horizontal">
            <el-radio v-model="retirementReason"
                      label="">작성하지않음</el-radio>
            <el-radio v-model="retirementReason"
                      label="일신상의 사정에 의해">일신상의 사정에 의해</el-radio>
            <el-radio v-model="retirementReason"
                      label="회사사정으로">회사사정으로</el-radio>
            <el-radio v-model="retirementReason"
                      label="계약기간 만료">계약기간 만료</el-radio>
            <el-radio v-model="retirementReason"
                      label="결혼">결혼</el-radio>
            <el-radio v-model="retirementReason"
                      label="출산">출산</el-radio>
            <el-radio v-model="retirementReason"
                      label="가족의 간호를 위해">가족의 간호를 위해</el-radio>
            <el-radio v-model="retirementReason"
                      label="병 치료를 위해">병 치료를 위해</el-radio>
          </div>
        </div>
      </div>

    </div>
    <div class="text-right">
      <el-button type="primary"
                 @click="setJobHistories()">추가하기</el-button>
      <el-button @click="$modal.hide('job-dialog');">닫기</el-button>
      <div v-show="errorMessage">{{ errorMessage }}</div>
    </div>
    <div class="text-right">
      <br/>
      <br/>
    </div>
  </modal>
</div>
</template>

<script>
export default {
  props: {
    birthYear: {
      type: [Number, String]
    },
    birthMonth: {
      type: [Number, String]
    },
    birthDay: {
      type: [Number, String]
    }
  },
  data: function () {
    return {
      resetDialogVisible: false,
      company: {},
      isContinuing: false,
      jobHistories: [],
      errorMessage: '',
      retirementReason: ''
    }
  },
  computed: {
    calcMinYear: function () {
      if (this.birthYear) {
        return Number(this.birthYear) + 15
      } else {
        return 1900
      }
    },
    calcMaxYear: function () {
      return new Date().getFullYear() + 3
    }
  },
  methods: {
    setJobHistories: function () {
      var companyCount = 0
      this.jobHistories = []
      this.errorMessage = ''

      var c = this.company
      if (c.isEmpty()) {
        console.log('c.isEmpty', c.isEmpty(), c)
        return
      }
      companyCount++
      this.jobHistories.push({
        year: c.startYear,
        month: c.startMonth,
        desc: c.name + '　입사'
      })
      if (this.isContinuing) {
        this.jobHistories.push({
          year: '',
          month: '',
          desc: '현재까지'
        })
      } else if (c.endYear) {
        this.jobHistories.push({
          year: c.endYear,
          month: c.endMonth,
          desc: c.name + '　' + this.retirementReason + ' 퇴사'
        })
      } else if (companyCount === 0) {
        this.errorMessage = '입력 해주세요'
        console.log(this.company)
        return
      }
      this.$emit('job-histories-created', this.jobHistories)
      this.$modal.hide('job-dialog')
    },
    setCompany: function (name, startYear, startMonth, endYear, endMonth) {
      var CompanyItem = function (name, startYear, startMonth, endYear, endMonth) {
        this.name = name || ''
        this.startYear = startYear || ''
        this.startMonth = startMonth || ''
        this.endYear = endYear || ''
        this.endMonth = endMonth || ''
        this.isEmpty = function () {
          return !(this.name || this.startYear || this.startMonth || this.endYear || this.endMonth)
        }
      }
      // console.log('addCompany', name, startYear, startMonth, endYear, endMonth)
      var company = new CompanyItem(name, startYear, startMonth, endYear, endMonth)
      this.company = company
    },
    resetCompanies: function () {
      this.setCompany()
      this.isContinuing = false
    }
  },
  watch: {},
  mounted: function () {}
}
</script>
